export const SAVE_INFO = "SAVE_INFO";
export const SHOW_LOCALS = "SHOW_LOCALS";
export const SAVE_USER = "SAVE_USER";
export const SAVE_WEDDING = "SAVE_WEDDING";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const UPDATE_ANSWERS = "UPDATE_ANSWERS";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const CLOSE_MENU = "CLOSE_MENU";
export const SAVE_UPGRADE = "SAVE_UPGRADE";
export const UPDATE_ABOUT_US = "UPDATE_ABOUT_US";
export const SAVE_CONTACT_CONFIRMATION = "SAVE_CONTACT_CONFIRMATION";